module.exports = __webpack_public_path__ + "static/img/graphics.c6aeabb7.svg";